import { gql } from "@apollo/client";

export const CUSTOMER_REGISTER_MUTATION = gql`
  mutation CustomerRegister(
    $firstName: String!
    $lastName: String!
    $email: String!
    $password: String!
    $phone: String!
    $role: CustomerRole!
  ) {
    customerRegister(
      first_name: $firstName
      last_name: $lastName
      email: $email
      password: $password
      phone: $phone
      role: $role
    ) {
      token
      user {
        id
        first_name
        last_name
        email
        phone
        role
        createdAt
      }
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      token
      user {
        id
        first_name
        last_name
        email
        phone
        role
        createdAt
      }
    }
  }
`;

export const VERIFY_PHONE_MUTATION = gql`
  mutation VerifyPhone($phone: String!) {
    verifyPhone(phone: $phone) {
      status
      message
    }
  }
`;

export const VERIFY_OTP_MUTATION = gql`
  mutation VerifyOtp($phone: String!, $otp: String!) {
    verifyOtp(phone: $phone, otp: $otp) {
      status
      message
      user {
        id
        first_name
        last_name
        email
        phone
        role
        createdAt
      }
      token
    }
  }
`;
